import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Input } from '@naf/input';
import { breakpoints, spacing } from '@naf/theme';
import { isNotTransientProp } from '../../../lib/shouldForwardProp';

export const FieldWrapper = styled.div<{ $hasMargin?: boolean }>`
  ${({ $hasMargin }) =>
    $hasMargin &&
    css`
      margin-top: ${spacing.space32};

      @media (min-width: ${breakpoints.m}) {
        margin-top: ${spacing.space40};
      }
    `}
`;

export const FullWidthTextField = styled(Input, { shouldForwardProp: isNotTransientProp })<{ $setWidth?: boolean }>`
  width: 100%;

  ${({ $setWidth }) =>
    $setWidth &&
    css`
      @media (min-width: ${breakpoints.m}) {
        width: 544px;
      }
    `}
`;
